import React, {useState, useEffect, useRef, useCallback} from "react";
import "../assets/css/trendingProfile.scss";
import "../../../../../../assets/css/stylesheet.scss";
import LeftSideBar from "../leftSideBar/LeftSideBar";
import RightSideBar from "../rightSideBar/RightSideBar";
import TrendingProfileCard from "./TrendingProfileCard";
import { Link } from "react-router-dom";
import {connect, useDispatch} from "react-redux";
import { followUserStart } from "../../../../../../redux/athlete/dashboard/homepage/followUnfollow";
import { trendingProfileListStart } from "../../../../../../redux/athlete/dashboard/homepage/trendingProfileList";
import {
  getAllAthletesDataQuery,
} from "../../../../../common/CommonQuery";
import { getUserInfo } from "../../../../../../services/authService";
import BackdropLoader from "../../../../../common/Loader";
import { athletesDetailsStart } from "../../../../../../redux/common/athletesDetails";
import GoTopButton from "../../editUserProfile/GoTopButton";
import {fetchMethod} from "../../../../../../services/httpService";
import {userProfileApi} from "../../../../../common/userViewCount";
import {imageDownloadUrl} from '../../../../../../config'

function TrendingProfile(props) {
  const [trendingProfileList, settrendingProfileList] = useState(null);
  const  [trendLimit, setTrendLimit] = useState(0)
  const  [trendOffset, setTrendOffset] = useState(0)
  const  [hasMore, setHasMore] = useState(true)
  const  [isLoading, setIsLoading] = useState(false)
  const  observer = useRef()
  const profileStatus = useDispatch()
  const  lastBookElementRef = useCallback(node => {
        if (isLoading) return
        if (observer?.current) observer?.current?.disconnect()
        observer.current = new IntersectionObserver(entires => {
          if (entires[0].isIntersecting && hasMore) {
            getTendingProfile(trendLimit, trendOffset)
          }
        })
        if (node) observer.current.observe(node)
      }, [hasMore, trendLimit]);
  useEffect(() => {
    getTendingProfile(trendLimit, trendOffset);
  }, []);
  const getTendingProfile = async (limit, offset) => {
    let isLimit = limit + 10
    const res = await fetchMethod(`/api/Userposts/TrendingData?loginUserId=${getUserInfo()?.id}&limit=${isLimit}&offset=${offset}`, null, 'GET', true)
    if (res?.status == 200 && res?.data?.response?.status == 200){
      const finalData = res?.data?.response?.data?.length > 0 ? res?.data?.response?.data : []
      settrendingProfileList(finalData)
      setTrendLimit(trendLimit + 10)
      if (res?.data?.response?.totalCount > finalData?.length){
        setHasMore(true)
      }else{
        setHasMore(false)
      }
    }
    // props.trendingProfileListStart({ userid: getUserInfo().id });
  };
  // useEffect(() => {
  //   if (props.trendingProfileList.data) {
  //     const tempData = props.trendingProfileList.data;
  //     settrendingProfileList(tempData);
  //   } else {
  //     settrendingProfileList(null);
  //   }
  // }, [props.trendingProfileList.data]);

  const handleFollowClick = (e, data) => {
    e.preventDefault();
    props.followUserStart({
      data: {
        followerId: `${getUserInfo().id}`,
        followingId: `${data.id}`,
      },
      refreshPage,
      follow: true,
    });
  };

  const refreshPage = () => {
    getTendingProfile();
    getUserData();
  };

  const getUserData = () => {
    props.athleteListStart({
      query: getAllAthletesDataQuery,
      variables: {
        obj: {
          id: getUserInfo() ? getUserInfo().id : 0,
        },
      },
    });
  };
  //func used for scrolling the page in top
  useEffect(()=>{
    setTimeout(()=>{
      window?.scrollTo(0,0)
    },1200)
  },[])
  const goTop=()=>{
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }
  const getInitials = (data) => {
    let initial = "";
    if(data.athleteFirstName){
      initial= data.athleteFirstName[0]?.toUpperCase().concat(data.athleteLastName ? data.athleteLastName[0]?.toUpperCase() : '');
    }
    return initial;
  };
  return (
    <div>
      <BackdropLoader
        open={props.followUnfollow.loading || props.trendingProfileList.loading}
      />
      <div className="trendingProfileSection">
        <div className="container">
          <div className="flexBox">
            <div className="leftDataBox">
              <LeftSideBar />
            </div>
            <div className="dataBox">
              <div className="backHome">
                <Link to="/homepage">
                  <span className="icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 447.243 447.243"
                    >
                      <path d="M420.361 192.229a31.967 31.967 0 00-5.535-.41H99.305l6.88-3.2a63.998 63.998 0 0018.08-12.8l88.48-88.48c11.653-11.124 13.611-29.019 4.64-42.4-10.441-14.259-30.464-17.355-44.724-6.914a32.018 32.018 0 00-3.276 2.754l-160 160c-12.504 12.49-12.515 32.751-.025 45.255l.025.025 160 160c12.514 12.479 32.775 12.451 45.255-.063a32.084 32.084 0 002.745-3.137c8.971-13.381 7.013-31.276-4.64-42.4l-88.32-88.64a64.002 64.002 0 00-16-11.68l-9.6-4.32h314.24c16.347.607 30.689-10.812 33.76-26.88 2.829-17.445-9.019-33.88-26.464-36.71z" />
                    </svg>
                  </span>
                  <span>Back to Homepage</span>
                </Link>
              </div>
              <div className="tabsBox">
                <h1 className="heading">Suggested for you</h1>
                <div className="tabFlex">
                  <div className="tab selected">
                    <Link to="#">Trending Profiles</Link>
                  </div>
                  <div className="tab">
                    <Link
                      to="#"
                      onClick={() =>
                        props.history.push("/homepage/suggestedcolleges")
                      }
                    >
                      Suggested Colleges
                    </Link>
                  </div>
                </div>

                <div className="followingDataBox"
                     style={ trendingProfileList?.length > 5 ?
                         {height: "460px", overflowY: "auto"} :
                         {} }
                >
                  {React.Children.toArray(
                    trendingProfileList &&
                      trendingProfileList.map((item, indx) =>{
                          if(trendingProfileList?.length == indx + 1){
                            return(
                                <>
           <div className="item"
              ref={lastBookElementRef}
           >
            <div className="imgDataFlexBox">
             <div className="imgBox">
              {!!item.profileImages ? (
               <img src={`${imageDownloadUrl}/${item.profileImages}`} alt="profile" className="image" style={{width: '100px', height: 'auto'}}/>
              ) : <div className = 'initialLetter'><span>{getInitials(item)}</span></div>
             }
            {props.data && props.data.verifiedUser ? (
            <span className="icon blueCheck">
              <svg
               xmlns="http://www.w3.org/2000/svg"
               width="26.418"
               height="26.403"
               viewBox="0 0 26.418 26.403"
              >
            <defs>
            <style></style>
            </defs>
            <path
              className="a"
              d="M-4229.021-6663.778a1.151,1.151,0,0,1-.986-.543,1.174,1.174,0,0,0-.993-.543,1.174,1.174,0,0,0-.993.543,1.151,1.151,0,0,1-.986.543,1.169,1.169,0,0,1-1.152-.9v-.005a1.179,1.179,0,0,0-1.149-.9,1.16,1.16,0,0,0-.728.256,1.169,1.169,0,0,1-.729.259,1.2,1.2,0,0,1-.883-.392,1.158,1.158,0,0,1-.3-.9l0-.013a1.161,1.161,0,0,0-.3-.9,1.184,1.184,0,0,0-.87-.387,1.181,1.181,0,0,0-.395.068h-.005a1.189,1.189,0,0,1-.4.07,1.175,1.175,0,0,1-.984-.544,1.155,1.155,0,0,1-.084-1.116l.01-.021a1.174,1.174,0,0,0-.088-1.121,1.175,1.175,0,0,0-.989-.538h-.033a1.163,1.163,0,0,1-1.08-.708,1.164,1.164,0,0,1,.219-1.274l.019-.019a1.171,1.171,0,0,0,.28-1.09,1.176,1.176,0,0,0-.769-.831l-.02,0a1.164,1.164,0,0,1-.8-1.02,1.164,1.164,0,0,1,.621-1.138l.02-.01a1.174,1.174,0,0,0,.621-.943,1.172,1.172,0,0,0-.456-1.031l-.02-.017a1.161,1.161,0,0,1-.425-1.223,1.164,1.164,0,0,1,.957-.875l.017,0a1.174,1.174,0,0,0,.894-.688,1.172,1.172,0,0,0-.1-1.125l-.013-.021a1.159,1.159,0,0,1-.058-1.2,1.173,1.173,0,0,1,1.03-.625,1.229,1.229,0,0,1,.215.019h.008a1.234,1.234,0,0,0,.21.019,1.166,1.166,0,0,0,.928-.459,1.169,1.169,0,0,0,.207-1.017l0-.017a1.148,1.148,0,0,1,.2-1.012,1.2,1.2,0,0,1,.938-.467,1.169,1.169,0,0,1,.572.151,1.16,1.16,0,0,0,.571.15,1.186,1.186,0,0,0,1.177-1.092v-.01a1.176,1.176,0,0,1,1.184-1.092,1.158,1.158,0,0,1,.866.39,1.159,1.159,0,0,0,.871.39,1.18,1.18,0,0,0,1.086-.715,1.162,1.162,0,0,1,1.084-.717,1.162,1.162,0,0,1,1.084.715,1.18,1.18,0,0,0,1.086.717,1.159,1.159,0,0,0,.871-.39,1.158,1.158,0,0,1,.866-.39,1.176,1.176,0,0,1,1.184,1.092v.01a1.186,1.186,0,0,0,1.177,1.092,1.16,1.16,0,0,0,.569-.148,1.164,1.164,0,0,1,.574-.153,1.2,1.2,0,0,1,.938.467,1.148,1.148,0,0,1,.2,1.012l-.005.017a1.169,1.169,0,0,0,.207,1.017,1.166,1.166,0,0,0,.928.459,1.234,1.234,0,0,0,.21-.019h.008a1.229,1.229,0,0,1,.215-.019,1.172,1.172,0,0,1,1.029.625,1.158,1.158,0,0,1-.057,1.2l-.013.021a1.172,1.172,0,0,0-.1,1.125,1.174,1.174,0,0,0,.894.688l.017,0a1.164,1.164,0,0,1,.958.875,1.161,1.161,0,0,1-.425,1.222l-.021.017a1.173,1.173,0,0,0-.456,1.032,1.174,1.174,0,0,0,.621.943l.021.01a1.164,1.164,0,0,1,.621,1.138,1.164,1.164,0,0,1-.8,1.02l-.02,0a1.179,1.179,0,0,0-.769.831,1.171,1.171,0,0,0,.283,1.09l.016.019a1.164,1.164,0,0,1,.218,1.273,1.163,1.163,0,0,1-1.08.708h-.033a1.175,1.175,0,0,0-.989.538,1.174,1.174,0,0,0-.088,1.121l.01.021a1.154,1.154,0,0,1-.083,1.116,1.175,1.175,0,0,1-.984.544,1.185,1.185,0,0,1-.4-.07h-.005a1.181,1.181,0,0,0-.395-.068,1.184,1.184,0,0,0-.87.387,1.161,1.161,0,0,0-.3.9v.013a1.157,1.157,0,0,1-.3.9,1.2,1.2,0,0,1-.883.392,1.159,1.159,0,0,1-.727-.259,1.164,1.164,0,0,0-.729-.256,1.181,1.181,0,0,0-1.15.9v0A1.168,1.168,0,0,1-4229.021-6663.778Zm-7.2-15.261a.709.709,0,0,0-.522.232l-1.041,1.122a.835.835,0,0,0,0,1.12l4.787,5.15a.712.712,0,0,0,.522.231.71.71,0,0,0,.52-.231l8.471-9.111a.84.84,0,0,0,0-1.122l-1.041-1.12a.711.711,0,0,0-.522-.232.705.705,0,0,0-.521.232l-6.908,7.43-3.226-3.469A.706.706,0,0,0-4236.221-6679.039Z"
              transform="translate(4244.209 6690.181)"
            />
            </svg>
            </span>
             ) : (
            <span className="icon redAlert">
             <svg
              xmlns="http://www.w3.org/2000/svg"
              width="25.828"
              height="25.997"
              viewBox="0 0 25.828 25.997"
             >
             <defs>
             <style></style>
            </defs>
            <g transform="translate(-306 -179)">
             <path
              className="a"
              d="M-5645.777-718.874a1.147,1.147,0,0,1,2.111,0l0,.009a1.147,1.147,0,0,0,1.91.317h0a1.146,1.146,0,0,1,2,.68l0,.034a1.146,1.146,0,0,0,1.7.916l.008,0a1.146,1.146,0,0,1,1.669,1.288l-.016.062a1.146,1.146,0,0,0,1.31,1.416l.033-.006a1.146,1.146,0,0,1,1.159,1.758l-.047.071a1.147,1.147,0,0,0,.776,1.761l.063.01a1.146,1.146,0,0,1,.521,2.038l-.071.055a1.146,1.146,0,0,0,.16,1.916l.074.04a1.146,1.146,0,0,1-.175,2.1l-.072.024a1.146,1.146,0,0,0-.474,1.864l.061.066a1.146,1.146,0,0,1-.852,1.924h-.049a1.147,1.147,0,0,0-1.058,1.61l.031.07a1.146,1.146,0,0,1-1.433,1.544l-.019-.007a1.147,1.147,0,0,0-1.527,1.182l0,.049a1.147,1.147,0,0,1-1.859,1l0,0a1.146,1.146,0,0,0-1.831.625l0,.02a1.146,1.146,0,0,1-2.082.344v0a1.146,1.146,0,0,0-1.937,0v0a1.146,1.146,0,0,1-2.082-.344l0-.02a1.146,1.146,0,0,0-1.831-.625l0,0a1.146,1.146,0,0,1-1.859-1l0-.049a1.146,1.146,0,0,0-1.527-1.182l-.019.007a1.146,1.146,0,0,1-1.434-1.544l.031-.07a1.146,1.146,0,0,0-1.057-1.61h-.049a1.146,1.146,0,0,1-.852-1.924l.061-.066a1.146,1.146,0,0,0-.474-1.864l-.072-.024a1.146,1.146,0,0,1-.175-2.1l.075-.04a1.146,1.146,0,0,0,.16-1.916l-.071-.055a1.146,1.146,0,0,1,.521-2.038l.062-.01a1.146,1.146,0,0,0,.777-1.761l-.047-.071a1.146,1.146,0,0,1,1.158-1.758l.034.006a1.146,1.146,0,0,0,1.31-1.416l-.016-.062a1.146,1.146,0,0,1,1.669-1.288l.008,0a1.146,1.146,0,0,0,1.7-.916l0-.034a1.146,1.146,0,0,1,2-.68h0a1.146,1.146,0,0,0,1.91-.317Z"
              transform="translate(5963.635 898.573)"
             ></path>
             <path
              className="b"
              d="M4.452-10.374,4.13-3.7H1.792L1.47-10.374ZM2.968.112A1.676,1.676,0,0,1,1.8-.287,1.309,1.309,0,0,1,1.358-1.3,1.33,1.33,0,0,1,1.8-2.324,1.658,1.658,0,0,1,2.968-2.73a1.638,1.638,0,0,1,1.155.406A1.33,1.33,0,0,1,4.564-1.3,1.315,1.315,0,0,1,4.123-.294,1.638,1.638,0,0,1,2.968.112Z"
              transform="translate(315.642 197.374)"
             ></path>
             </g>
             </svg>
              </span>
               )}
        </div>
          <div className="dataFlexBox">
        <div>
          <h5 onClick={()=>{
          profileStatus({type:"CHANGE_ATHLETE_PROFILE_VIEW_STATE", payload:{
            id: item?.id || 0,
           status: true
                }});
          localStorage.setItem('pubViewID',props?.data.id || 0)
         userProfileApi({obj:{userrole:"ATHLETES", profileviewedby: getUserInfo()?.id ?? 0, profileviewto: +item?.id || 0 }},true, false)
        }}>
        <Link to={`/publicProfile/1/${item?.id}`}
        target="_blank"
        >
        {item
         ? item.athleteFirstName +
         " " +
         item.athleteLastName
        : ""}
        </Link>
         </h5>
        <ul>
        <li>
         <span style={{marginRight: "5px"}}>
                    {item ? item.sportName : ""} - {" "}
                    {item
                        ? item.primaryPosition
                            ? item.primaryPosition
                            : item.secondaryPosition
                                ? `${item.secondaryPosition} `
                                : ""
                        : ""}
                  </span>
                                            </li>
                                            <li>
                  <span style={{margin:"0 5px 0 5px"}}>
                    Grad Year {item ? item.yearValue : ""}
                  </span>
                                            </li>
                                          </ul>
                                          <ul>
                                            <li>
                                              {/*<span>*/}
                                              {/*  {props.data ? props.data.totalFollowers : 0} Followers*/}
                                              {/*</span>*/}
                                            </li>
                                            <li>
                                              {/*<span>*/}
                                              {/*  {props.data ? props.data.totalFollowing : 0} Follow*/}
                                              {/*</span>*/}
                                            </li>
                                          </ul>
                                        </div>
                                        <div className="action">
                                          {item && item.followeingStatus ? (
                                              <></>
                                              // <Link to="#" className="followerLink">
                                              //   Followed
                                              // </Link>
                                          ) : (
                                              <></>
                                              // <Link
                                              //   to="#"
                                              //   className="followerLink"
                                              //   onClick={(e) => props.handleFollowClick(e, props.data)}
                                              // >
                                              //   Follow
                                              // </Link>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </>

                            )
                    }else {
                            return(
                                <TrendingProfileCard
                                    data={item}
                                    handleFollowClick={handleFollowClick}
                                />

                            )
                    }
                      })
                  )}
                </div>
              </div>
            </div>
            <div className="rightDataBox">
              <RightSideBar />
            </div>
          </div>
        </div>
      </div>
      <GoTopButton  goTop={goTop}/>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    trendingProfileList: state.athlete.dashboard.home.trendingProfileList,
    followUnfollow: state.athlete.dashboard.home.followUnfollow,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    trendingProfileListStart: (data) =>
      dispatch(trendingProfileListStart(data)),
    followUserStart: (data) => dispatch(followUserStart(data)),
    athleteListStart: (data) => dispatch(athletesDetailsStart(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TrendingProfile);
